/* --------------------------------------------------------------------------------------
   data.service.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export class dataService {
  /*@ngInject*/
  constructor($http, $q, appSettings, deviceInfoService, commonService) {
    this.$http = $http
    this.$q = $q
    this.appSettings = appSettings
    this.deviceInfoService = deviceInfoService
    this.commonService = commonService
  }
  setUserAuthData(accesstoken64, refreshtoken64) {
    return this.refreshToken(accesstoken64, refreshtoken64)
      .then(result => {
        this.userData = result
        return result
      })
  }
  getToken(user64, password64) {
    let headers = {
      'GravicUser64': user64,
      'GravicPassword64': password64,
      'GravicLanguage': this.commonService.getLanguage(),
      'x-country' : this.getCountryValue()
    }
    let endpoint = this.appSettings.apiUrl + '/auth/token'
    return this.$http.get(endpoint, { headers: headers })
      .then(result => {
        if (result.data.XrxSuccess)
          return Promise.resolve(result.data)
        else
          return Promise.reject(result.data.XrxMessage)
      })
  }
  refreshToken(accessToken64, refreshToken64) {
    let headers = {
      'GravicToken64': accessToken64,
      'GravicRefresh64': refreshToken64,
      'GravicLanguage': this.commonService.getLanguage(),
      'x-country' : this.getCountryValue()
    }
    let endpoint = this.appSettings.apiUrl + '/auth/token/refresh'
    return this.$http.get(endpoint, { headers: headers })
      .then(result => {
        return result.data
      })
  }
  getEncrypted64(password64) {
    let endpoint = this.appSettings.apiUrl + '/utility/encrypt64/' + password64
    return this.$http.get(endpoint)
      .then(result => {
        return result.data
      })
  }
  getUserFullName(tempUserData) {
    let endpoint = this.appSettings.apiUrl + '/user/name' + getEndpointParameters(tempUserData, [])
    let headers = {
      'GravicToken64': tempUserData.access_token_64,
      'GravicLanguage': this.commonService.getLanguage(),
      'x-country' : this.getCountryValue()
    }
    return this.$http.get(endpoint, { headers: headers })
      .then(result => { return result.data })
  }
  GetClasses() {
    let endpoint = getListEndpoint(this.appSettings.apiUrl, this.userData, "classes", arguments)
    return this.$http.get(endpoint, { headers: this.getStandardHeaders() })
      .then((result) => {
        //result.data.XrxSuccess = false
        //result.data.XrxMessage = "error this is an error"
        if (!result.data.XrxSuccess)
          return this.$q.reject(result.data.XrxMessage)
        return result.data.Classes
      })
  }
  GetTests() {
    let endpoint = getListEndpoint(this.appSettings.apiUrl, this.userData, "tests", arguments)
    return this.$http.get(endpoint, { headers: this.getStandardHeaders() })
      .then((result) => {
        if (!result.data.XrxSuccess)
          return this.$q.reject(result.data.XrxMessage)
        return result.data.Tests
      })
  }
  GetRoster() {
    let endpoint = this.appSettings.apiUrl + '/classes/roster'
    endpoint = endpoint + getEndpointParameters(this.userData, arguments)
    return this.$http.get(endpoint, { headers: this.getStandardHeaders() })
      .then((result) => {
        if (!result.data.XrxSuccess)
          return this.$q.reject(result.data.XrxMessage)
        return result.data.Students
      })
  }
  GetResults() {
    let endpoint = this.appSettings.apiUrl + '/tests/students/grades'
    endpoint = endpoint + getEndpointParameters(this.userData, arguments)
    return this.$http.get(endpoint, { headers: this.getStandardHeaders() }).then((result) => {
      return result.data //return the entire object, parsed internally
    })
  }
  GetEmailStudents() {
    let endpoint = this.appSettings.apiUrl + '/reports/email/studentreports'
    endpoint = endpoint + getEndpointParameters(this.userData, arguments)
    return this.$http.get(endpoint, { headers: this.getStandardHeaders() }).then((result) => {
      return result.data
    })
  }
  GetReports() {
    let endpoint = getListEndpoint(this.appSettings.apiUrl, this.userData, "reports", arguments)
    return this.$http.get(endpoint, { headers: this.getStandardHeaders() }).then((result) => {
      return result.data.Reports
    })
  }
  GenerateReport() {
    let endpoint = this.appSettings.apiUrl + '/reports/generate'
    endpoint = endpoint + getEndpointParameters(this.userData, arguments)
    return this.$http.get(endpoint, { headers: this.getStandardHeaders() }).then((result) => {
      return result.data
    })
  }
  getScanTicket() {
    let endpoint = this.appSettings.apiUrl + '/scan/ticket'
    endpoint = endpoint + getEndpointParameters(this.userData, arguments)
    return this.$http.get(endpoint, { headers: this.getStandardHeaders() }).then((result) => {
      return result.data
    })
  }
  getProcessImage() {
    let endpoint = this.appSettings.apiUrl + '/user/image/process'
    endpoint = endpoint + getEndpointParameters(this.userData, [])
    return this.$http.get(endpoint, { headers: this.getStandardHeaders() }).then((result) => {
      return result.data
    })
  }
  postPrintTests(classId, testId, answerKey, students) {
    var params = [classId, testId, answerKey]
    let endpoint = this.appSettings.apiUrl + '/answersheet/generate'
    endpoint = endpoint + getEndpointParameters(this.userData, params)
    if (students) {
      return this.$http.post(endpoint, { students: students }, { headers: this.getStandardHeaders() }).then((result) => {
        return result.data
      })
    }
    else {
      return this.$http.post(endpoint, {}, { headers: this.getStandardHeaders() }).then((result) => {
        return result.data
      })
    }
  }
  postSendEmailReports(classId, testId, reportIds) {
    let endpoint = this.appSettings.apiUrl + '/reports/email'
    let params = []
    params.push(classId)
    params.push(testId)
    endpoint = endpoint + getEndpointParameters(this.userData, params)
    return this.$http.post(endpoint, { reports: reportIds }, { headers: this.getStandardHeaders() }).then((result) => {
      return result.data
    })
  }
  postLog(message) {
    let endpoint = this.appSettings.apiUrl + '/log'
    return this.$http.post(endpoint, { data: message }, { headers: this.getStandardHeaders() }).then((result) => {
      return result.data
    })

  }
  initializeStandardHeaders() {
    return this.deviceInfoService.get()
      .then(result => {
        this.standardHeaders = {
          'GravicToken64': this.userData.access_token_64,
          'PaperPreferenceA4': result.paperPreferenceA4,
          'DeviceModel': result.model,
          'DeviceEip': result.eipSoftware,
          'DeviceLocalizationCountry': result.localizationCountry,
          'LocalizationLanguage': result.localizationLanguage,
          'DeviceUiSoftware': result.uiSoftware,
          'x-country' : this.getCountryValue()
        }
        return this.userData
      })

    //return {'GravicToken64' : this.userData.access_token_64, 'GravicLanguage': this.commonService.getLanguage()}
  }
  getStandardHeaders() {
    return this.standardHeaders
  }

  getCountryValue() {    
    return location.search.length ? location.search.split("=")[1] : ''
  }

}
let getListEndpoint = (address, userData, entity, params) => {
  let endpoint = address + '/' + entity + '/list'
  endpoint = endpoint + getEndpointParameters(userData, params)
  return endpoint
}

let getEndpointParameters = (userData, params) => {
  var result = '/' + userData.client_id + '/' +
    userData.account_id + '/' +
    userData.user_id
  for (var i = 0; i < params.length; i++) {
    result = result + '/' + params[i];
  }
  return result;
}





// WEBPACK FOOTER //
// ./src/app/common/services/data.service.js